import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import React from "react";
import { useTranslation } from "react-i18next";

const CustomModal = ({
  show,
  hideModal,
  modalTitle,
  children,
  actionSubmitModal,
  classValue,
  size,
  backdrop = "static",
  centered = false,
  footerContent = true,
  keyboard = true,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={hideModal}
      size={size}
      animation={true}
      backdropClassName="glass-backdrop"
      contentClassName="glass-content"
      dialogClassName="glass-dialog"
      backdrop={true} // ⬅️ promenjeno sa "static" na true
      keyboard={keyboard} // ⬅️ omogući zatvaranje i klikom van modala i tipkom Esc
      className={classValue}
      centered={centered}
      aria-labelledby="example-modal-sizes-title-sm"
    >
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default CustomModal;
